export default "__VITE_ASSET__CRzgQf7m__"